import { useEffect } from "react";
import { Alert, Dialog } from "@mui/material";

import { useRuleWizardContext } from "../../providers/RuleWizardProvider";

import WizardStep1 from "./steps/WizardStep1";
import WizardStep2 from "./steps/WizardStep2";
import WizardStep3 from "./steps/WizardStep3";
import WizardStep4 from "./steps/WizardStep4";
import WizardStep5 from "./steps/WizardStep5";
import { WizardContainer } from "./styled/rule-wizard.styled";
import RuleWizardHeader from "./RuleWizardHeader";

export default function RuleWizard() {
	const { 
		activeStep, 
		initEditingRule, 
		initPlatforms,
		handleExitEditing, 
		wizardFormError, 
		setWizardFormError,
		editedId
	} = useRuleWizardContext();

	const getStepContent = (step) => {
		switch (step) {
			case 0:
				return <WizardStep1/>;
			case 1:
				return <WizardStep2/>;
			case 2:
				return <WizardStep3/>;
			case 3:
				return <WizardStep4/>;
			case 4:
				return <WizardStep5/>;
			default:
				return "Unknown step";
		}
	};

	useEffect(() => {
		if (editedId) {
			initEditingRule();
		}
		initPlatforms();
		const handleEsc = (event) => {
			if (event.key === "Escape") {
				handleExitEditing();
			}
		};

		window.addEventListener("keydown", handleEsc);

		return () => {
			window.removeEventListener("keydown", handleEsc);
		};
	}, []);

	return (
		<WizardContainer>
			<form noValidate autoComplete="off">
				<div>
					<RuleWizardHeader />
				</div>
				<div>{getStepContent(activeStep)}</div>
			</form>
			<Dialog onClose={() => setWizardFormError("")} open={wizardFormError !== ""}>
				<Alert severity="error">{wizardFormError}</Alert>
			</Dialog>
		</WizardContainer>
	);
}